/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeUnexpectedPaymentOutcomeGetResponseSchema } from './changeUnexpectedPaymentOutcomeGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getChangeUnexpectedPaymentOutcome200Schema = z.lazy(() => changeUnexpectedPaymentOutcomeGetResponseSchema);

/**
 * @description 505 response
 */
export const getChangeUnexpectedPaymentOutcome505Schema = z.any();

export const getChangeUnexpectedPaymentOutcomeQueryResponseSchema = z.lazy(
  () => getChangeUnexpectedPaymentOutcome200Schema
);
